import { useEffect, useState } from 'react';
import './menu.css';
import { useUser } from '../../UserContext';
import { useNavigate } from 'react-router-dom';
import Icon from '../Icon';
import ConfirmationModal from '../ConfirmationModal';
import { logout } from '../../services/api';

function Menu() {
    const { user, photo } = useUser();
    const [preview, setPreview] = useState(undefined);
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!photo) {
            setPreview(undefined);
            return;
        }

        const objectUrl = URL.createObjectURL(photo);
        setPreview(objectUrl);

        return () => URL.revokeObjectURL(objectUrl);
    }, [user, photo]);

    function handleUserInitials() {
        if (!user || !user.name || !user.lastName)
            return '';

        return user.name[0] + user.lastName[0];
    }

    function handleClickLogout() {
        setShowLogoutConfirmation(true);
    }

    function handleConfirmLogout() {
        setShowLogoutConfirmation(false);
        logout();
    }

    return (
        <>
            <div id='menu-admin'>
                <div className='user-data glass-effect-15'>
                    {!!preview && ( 
                        <img src={preview} alt='Foto do utilizador' /> 
                    )}

                    {!preview && (
                        <span className="user-initials">{handleUserInitials()}</span>
                    )}

                    <div className='user-info'>
                        <h1>{`${user.name} ${user.lastName}`}</h1>
                        <p>Admin</p>
                    </div>
                </div>

                <ul>
                    <li onClick={() => navigate('/users')}>
                        <span className='zoom-effect menu-item-content'>
                            <Icon iconClass='icon-users' size={22} />
                            Usuários
                        </span>
                    </li>
                    
                    <li onClick={() => navigate('/modules')}>
                        <span className='zoom-effect menu-item-content'>
                            <Icon iconClass='icon-course' size={22} />
                            Curso
                        </span>
                    </li>

                    <li onClick={() => navigate('/instructors')}>
                        <span className='zoom-effect menu-item-content'>
                            <Icon iconClass='icon-instructor' size={22} />
                            Professores
                        </span>
                    </li>

                    <li onClick={() => navigate('/news')}>
                        <span className='zoom-effect menu-item-content'>
                            <Icon iconClass='icon-news' size={22} />
                            Notícias
                        </span>
                    </li>

                    <li onClick={() => navigate('/appearance')}>
                        <span className='zoom-effect menu-item-content'>
                            <Icon iconClass='icon-appearance' size={22} />
                            Aparência
                        </span>
                    </li>

                    <li onClick={() => navigate('/configs')}>
                        <span className='zoom-effect menu-item-content'>
                            <Icon iconClass='icon-gear' size={22} />
                            Configurações
                        </span>
                    </li>

                    <li className='menu-logout'>
                        <span className='menu-item-content menu-logout-content' onClick={handleClickLogout}>
                            <Icon iconClass='icon-logout' size={22} />
                            Sair
                        </span>
                    </li>
                </ul>

            </div>

            <ConfirmationModal
                show={showLogoutConfirmation}
                title='Confirmar saída'
                description='Deseja realmente sair da sua conta?'
                onConfirm={handleConfirmLogout}
                onClose={() => setShowLogoutConfirmation(false)}
            />
        </>
    );
}

export default Menu;